import React from "react";
import "../assets/css/slider.css"; // Custom styling
import PdfViewer from "../components/PdfViewer";

const BrochureSkyCrest8 = () => {
    return (
        <div className="slider-container">
            <embed
                src="https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Real_Walk_Files/Brochure/Sky+Crest+8_Brochure_V10.pdf"
                type="application/pdf"
                width="100%"
                height="100%"
            />
            {/* <iframe
                src={`https://docs.google.com/gview?url=https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Real_Walk_Files/Brochure/Sky+Crest+8_Brochure_V10.pdf`}
                style={{ width: "100vw", height: "100vh" }}
            /> */}
            <iframe
                src="https://drive.google.com/viewerng/viewer?embedded=true&url=https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Real_Walk_Files/Brochure/Sky+Crest+8_Brochure_V10.pdf"
                style={{ width: "100vw", height: "100vh" }}
            />
            {/* <PdfViewer fileUrl="/Courtyard/brochure/Payment_Plan.pdf" /> */}
            {/* <PdfViewer fileUrl="https://www.orimi.com/pdf-test.pdf" /> */}
            {/* <iframe widdth="100%" height="100vh" src="https://surbhi-infotech.s3.ap-south-1.amazonaws.com/Real_Walk_Files/Brochure/Sky+Crest+8_Brochure_V10.pdf" style={{ width: "100vw", height: "100vh" }} /> */}
        </div>
    )
}

export default BrochureSkyCrest8;